"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findPrintableInProject;
function findPrintableInProject(project, printableId) {
  let printable;
  for (const pg of project.printableGroups) {
    printable = pg.printables.find(p => p.id === printableId);
    if (printable) {
      return printable;
    }
  }
}